import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function NewsPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>News</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p style={{ fontSize: "1.2em" }}>
              <ul>
                <br />
                <li>
                  <b>The New Indian Express -</b> Western Ghats under pressure:
                  Goa sees 11% drop in evergreen cover, forest value pegged at
                  Rs 481 bn a year
                  <a href="PDF/Goa_Indian Express.pdf">.....Read more</a>
                </li>
                <br />
                <li>
                  <b>The Hindu -</b> Market forces have led to change and
                  degradation of forest ecosystems in Goa: Study
                  <a href="/PDF/The hindu_NEWS.pdf">.....Read more</a>
                </li>
              </ul>
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default NewsPage;
